import { formatPrice } from './format-price'

export const getPriceChipLabel = (priceFrom?: string, priceTo?: string): string => {
	if (priceFrom && priceTo) {
		return `от ${formatPrice(priceFrom)} до ${formatPrice(priceTo)} ₽`
	}

	if (priceFrom) return `от ${formatPrice(priceFrom)} ₽`
	return `до ${formatPrice(priceTo)} ₽`
}
